import { render, staticRenderFns } from "./SponsoringIcon.vue?vue&type=template&id=2a88e3fb&scoped=true&"
import script from "./SponsoringIcon.vue?vue&type=script&lang=js&"
export * from "./SponsoringIcon.vue?vue&type=script&lang=js&"
import style0 from "./SponsoringIcon.vue?vue&type=style&index=0&id=2a88e3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88e3fb",
  null
  
)

export default component.exports